import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询商品分类
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductCategory(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryProductCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询收银商品详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryCashierProductDetail(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/product/queryCashierProductDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}